import React from 'react';
import { Reveal, SectionLabel } from './Section';
import { INTELLECTRA_LOGO } from '../data/content';

const CARDS = [
  { num:'01', title:'A Project With Every Module', desc:"You don't just learn a tool — you ship with it. Each module ends in a hands-on project across analytics and ML, so you gain practical, in-hand experience from every module as you go." },
  { num:'02', title:'2 End-to-End Industry Projects', desc:"Two complete, real-world data science projects that take you from raw data to deployed ML model — the exact kind of work recruiters want to see." },
  { num:'03', title:'100% Real-Time Projects', desc:"No sample datasets. All projects are real-time industry problem statements from our technology partner Intellectra AI." },
];

export default function Projects() {
  return (
    <section id="projects" className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal><SectionLabel>Projects & Portfolio</SectionLabel></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[66px] leading-[1.02] font-semibold text-[#293891] mt-6 max-w-4xl">
            You graduate with <span className="text-[#E63329]">proof</span>, not just a certificate.
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-4 mt-14">
          {CARDS.map((c,i) => (
            <Reveal key={c.num} delay={i*0.08}>
              <div className="card-lift bg-white border border-[#293891]/10 rounded-3xl p-8 h-full">
                <div className="big-num text-[64px] leading-none">{c.num}</div>
                <h3 className="font-display text-[22px] font-semibold text-[#293891] mt-4">{c.title}</h3>
                <p className="text-[13.5px] leading-relaxed text-[#293891]/70 mt-4">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-10 bg-white border border-[#293891]/10 rounded-3xl p-8 lg:p-10 grid lg:grid-cols-[auto_1fr] gap-8 items-center">
            <div className="flex items-center gap-6">
              <div className="text-[11px] tracking-[0.25em] uppercase font-semibold text-[#293891]/70">Technology Partner</div>
              <img src={INTELLECTRA_LOGO} alt="Intellectra AI" className="h-14 w-auto"/>
            </div>
            <p className="text-[14px] leading-relaxed text-[#293891]/75">
              Every project you build — from EDA and ML models to deployed AI agents — is a live, real-time problem statement powered by our technology partner Intellectra AI. Real data, real stakes, real experience.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
